module.exports = __webpack_public_path__ + "static/assets/423c0e5bfcd40aefdfda7f7b593c534b.png";